import { BaseModel } from './base.model'
import { Center } from './center.model'
import { Program } from './program.model'
import { AccessCondition } from './access-condition.model'
import { CenterProgramRetakeExamSetting } from './center-program-retake-exam-setting.model'
import { Constants } from 'config'

export interface SmsTextTranslation {
  code: string,
  successText: string,
  failText: string
}

export interface SmsAfterFinishRule {
  course: string
  translations: { [code: string]: string[] }
}

export class CenterProgram extends BaseModel<CenterProgram> {
  static DEFAULT_ATTRIBUTES = {
    smsAfterFinish: false,
    needInterview: false,
    needBriefing: false,
    smsTextTranslations: [],
    accessConditions: [],
    smsAfterFinishRules: [
      {
        course: null,
        translations: {}
      },
      {
        course: "_fail",
        translations: {}
      }
    ],
    retakeExamSettings: Array.from({ length: Constants.EXAMS.MAX_GRADE + 1 }, (value, key) => Constants.EXAMS.MIN_GRADE + key).map(grade => { 
      return new CenterProgramRetakeExamSetting({ 
        grade: grade, 
        daysCount: [0],
        enabled: false,
        online: false
      }) 
    }),
    webRetakeExamSettings: [1,2,5].map(grade => new CenterProgramRetakeExamSetting({ 
      grade: grade, 
      daysCount: [0],
      enabled: false,
      online: true
    })),
    exportToCourses: [],
    driverRating: 0,
    position: 0,
    interviewReminderSmsId: null,
    interviewRegistrationSmsId: null,
    interviewCancellationSmsId: null,
    briefingIds: [],
    _centerId: null
  }

  id: number
  center: Center
  password: string
  program: Program
  accessConditions: AccessCondition[]
  smsAfterFinish: boolean
  needInterview: boolean
  interviewSlotsMandatory: boolean
  needBriefing: boolean
  briefingSlotsMandatory: boolean
  hideResults: boolean
  smsTextTranslations: SmsTextTranslation[]
  smsAfterFinishRules: SmsAfterFinishRule[]
  retakeExamSettings: CenterProgramRetakeExamSetting[]
  webRetakeExamSettings: CenterProgramRetakeExamSetting[]
  interviewId: number
  exportToCourses: string[]
  driverRating: number
  interviewRegistrationSmsId: number
  interviewCancellationSmsId: number
  interviewReminderSmsId: number
  interviewReminderSmsTime: number
  position: number
  state: string
  briefingIds: number[]
  _centerId: number

  get programId(): number|null {
    return this.program ? this.program.id : null
  }

  get centerId(): number|null {
    return this.center ? this.center.id : this._centerId
  }

  set centerId(id) {
    this._centerId = id
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/center-program.model.ts